import {  Link } from "react-router-dom"
import history from "../../../history"


import Terrain from '../../terrain/Terrain'
import MotelTerrain from '../../terrain/MotelTerrain'
import TerrainStars from '../../terrain/TerrainStars'
   //import FacetBar from '../../esfind/FacetBar'
 
  import ErrorCom from '../../core/AbodeErrorTag'
  import SVAbodeSpinner from '../../core/SVAbodeSpinner';

   import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
   import { Icon, Button , Row, Col, Badge } from 'antd';
//import TerrainLocationListView from '../../terrain/TerrainLocationListView'
import OrderListView from '../../terrain/OrderListView'
import '../../../css/svlist_styles.css'
   const React = require('react')

  
    
   const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );

   const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

  
class OrderContainer extends React.Component {

    constructor(props){

        super(props)
        let me = this
        this.getChildContainersList = this.getChildContainersList.bind(me)
        this.starBody = this.starBody.bind(me)
        this.getChildContainersTerrain = this.getChildContainersTerrain.bind(me)
        this.closecbParent = this.closecbParent.bind(this)
        this.title = 'My Orders /Reservations'
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)
 
        

    }
    closecbParent(){
        let svCustomerId = this.props.svparams.id
        console.log('svCustomerId*********')
        console.log(svCustomerId)
        history.push(`/myreservationsSV/${svCustomerId}`)
      }
    
/*
    getAppDetails(paramQ){
        
        // this.props.getSoDetails("mancreek")
 
        this.props.ordAndImagesSV()
        
     }
*/
     componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        console.log(this.props.svparams)
         //console.log(this.props.svparams.id)
         let id = 6;
         if(this.props.svparams){
            id = this.props.svparams.id
         
         }else{
          console.log('not called by router')
          id = 6;
         }
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
     /*   this.state = {
          tasks: svtasks[0]
        }
    */
    
        const { cookies } = this.props;
        const svtv = cookies.get('svt')
        this.props.ordAndImagesSVSecure(id, svtv);
   
			
	

	}

     deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
    //<TerrainStars svrstars={svrstars} ></TerrainStars>
    starBody(o){
        let svrstars = {
            "sv_rating_no":o.avg_stars_rating ? o.avg_stars_rating : 5  ,
            "color": "#e8a01899"
        }
        return(<TerrainStars svrstars={svrstars} ></TerrainStars>)

    }
    getChildContainersTerrain() {
       
        let customerId =  ( this.props.svparams &&  this.props.svparams.id ) ? this.props.svparams.id : -1
        console.log('customerId:', customerId)
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')

        return (
            <div className="svr-det-pageWrapper">
               
                <header className="svr-header1">
                    <h1><span> <text style={{color:'#f0d8a9'}}> My Orders / Rservations View </text><Link to={`/myaccountSV/${customerId}/mysvspaceSearch`}><Icon  style={{ color: '#eeb838' }} type="plus-square" theme="filled" /> </Link><Link to={`/myaccountSV/${customerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                </header>
                {this.getChildContainersList()}
             
           </div>   
             )   
      }
    getChildContainersList(){

        const size = 'small'
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.svesorder.data && (this.props.svesorder.data.length > 0)) {
            data = this.props.svesorder.data
        }
        if (this.props.svesorder.sojourns && (this.props.svesorder.sojourns.length > 0)) {
            sojourns = this.props.svesorder.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.svesorder && this.props.svesorder.my_data && (this.props.svesorder.my_data.length > 0)) {
            my_data = this.props.svesorder.my_data
        }else if(this.props.my_data && (this.props.my_data.length > 0)){
            my_data = this.props.my_data
        }

        const {svesorder, locationDataView} = this.props
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
        console.log(this.props)
       

        let customerId =  ( this.props.svparams &&  this.props.svparams.id ) ? this.props.svparams.id : -1
        console.log('customerId:', customerId)
        console.log(this.props)
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
        const svmsg = "There is error . Plese try later"
      
        if(this.props.svesorder.error){
            console.log('sv**container ger errob')
           
           return (
             <div >
                
                 <div style={{paddingTop:'10px'}}>
                   <ErrorCom  closecbParent={this.closecbParent} errob={this.props.errob} ></ErrorCom>
                 </div>
                 <div style={{paddingTop:'10px'}}>
                     <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/svprofile`}> My Reservations   </Link></Button>
                 </div>
                
              </div>   
                )
   
          }else if(this.props.svesorder.loading ){
           return (
   
             <div >
                <h3>Spinner*****</h3>
             <div style={{paddingTop:'10px'}}>
            

               <SVAbodeSpinner />
             </div>
            
            
          </div>   
   
           
                 )
   
          }else {
      
        return (

       
               
               
        
                <div className="svr-spacelist-contentWrapper">
                    <article className="main-listhotels">
                    {
                            my_data.map(o => {
                                let soj = o
                                //convet keys of o to uppercase
                                console.log('sv***soj**')
                                console.log(soj)
                                let reservekey = 'insvreview'
                                let svr_location = {
                                    "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                                    "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                                    "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                                    "county": soj['county'] ? soj['county'] : "albanyt",
                                    "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                                    "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                                    "country": soj['country_name'] ? soj['country_name'] : "usa",
                                   "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                                   "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                                    
                                   "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                                   "state":soj['state'] ? soj['state'] : "NY"
    
                                }

                                let svr_price = {
                                    "addressId" :soj['addressId'] ? soj['addressId'] : -3,
                                    "customerId" :soj['customerId'] ? soj['customerId'] : -3,
                                    "orderId" :soj['orderId'] ? soj['orderId'] : -3,
                                    "orderItemStatusCode": soj['orderItemStatusCode'] ? soj['orderItemStatusCode'] : 3,
                                    "salePrice": soj['salePrice'] ? soj['salePrice'] : "800",
                                    "startDateStay": soj['startDate'] ? soj['startDate'] :"2024-11-20",
                                    "endDateStay": soj['endDate'] ? soj['endDate'] : "2024-12-05",
                                    "currency": soj['currency'] ? soj['currency'] : "USD",
                                    "abodeSpaceId": soj['abodeSpaceId'] ? soj['abodeSpaceId'] : "10000295",
                                    "spaceKey": soj['spaceKey'] ? soj['spaceKey'] :"10000295@4@F@10@10@20251124@7@Y@SVR",
                                    "reservationConfirmCode": soj['reservationConfirmCode'] ? soj['reservationConfirmCode'] : "AHLKA",
                                }
                                if(svr_price['orderItemStatusCode'] == 1){
                                    svr_price['orderItemStatusCodeDesc'] = 'Completed'
                                }else if(svr_price['orderItemStatusCode'] == 2){
                                    svr_price['orderItemStatusCodeDesc'] = 'Completed'
                                }else if(svr_price['orderItemStatusCode'] == 3){
                                    svr_price['orderItemStatusCodeDesc'] = 'Cancelled'
                                }else{
                                    svr_price['orderItemStatusCodeDesc'] = 'Unknown'
                                }
                                if(svr_price['currency'] == 'USD'){
                                    svr_price['totalWithCurrency'] = '$'+ svr_price['salePrice']
                                }else{
                                    svr_price['totalWithCurrency'] = svr_price['currency'] + svr_price['salePrice']
                                }
                                return (
                                    <div className="svr-spacelist-box-row1">
                                    <div className="svr-spacelist-boxr-1">
                                        <div className="gallery">
                                            <figure>
                                            <span  >	<Link to={`/myaccountSV/${customerId}/svspacedet/${o.space_key}`}> 
                                            
                                            <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                             </Link> </span>
                                                
                                            </figure>
                                        </div>
                                    </div>
                    
                                    <div className="svr-spacelist-boxl-2">
                                        <div className="box-outer-listhotels">
                                            <div className="box-left-listhotels">
                                            
                                            <OrderListView reservekey={reservekey}  svrprice={svr_price} svrlocation={svr_location}></OrderListView>
                                        {/*  
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">{o.sojourn_name}</text>
                                                <span className="ter-l2 svr-hotel-location">{o.city_name?  o.city_name: "NamCity"} <Icon  style={{ color: '#eb2f96' }} type="environment" theme="filled" /><text>Shown On Map</text> <text>{o.nearest_airport_distance_mi? o.nearest_airport_distance_mi : '4' } miles from <span style={{fontSize: "14px"}} > <Icon  style={{ color: 'rgb(8, 44, 128)' }} type="dribbble-circle" theme="filled" /><text style={{paddingLeft: "3px"}}> {o.nearest_airports? o.nearest_airports : 'orlando Aiport'}</text></span>
                                            
                                                        awaysvGGL</text></span>
                                                       
                                                <span style={{fontSize: "18px"}} > <Icon  style={{ color: '#eb2f96' }} type="dingtalk-square" theme="filled" /><text style={{paddingLeft: "10px"}}>HoteSV Website</text></span>
                                                
                                            </p>
                                        */} 
                                            
                                            </div>
                                            <div className="box-right-listhotels">
                                            
                                            
                                            <p className="m-para-text-first">
                                                    <text className="svr-hotel-rating">{o.sv_rating?  o.sv_rating: "Excellent"}  </text>
                                                    <text className="f12 d-block">{o.avg_stars_rating ? o.avg_stars_rating : 5 } rating </text>
                                                    {this.starBody(o)}
                                                </p>
                                            
                                              
                                            </div>``
                                        </div>
                    
                    
                                        <div className="box-outer-listhotels" style={{fontSize:"1.0em"}}>
                                            <div className="box-left-listhotels">
                                                {/* 
                                            <p className="m-para-text">
                                                {this.getHotelAmenityList(o.activity_name)}
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Wifi</text></span>
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Bath tub</text></span>
                                                
                                            </p>
                                            */}
                                               
                                            </div>
                                            <div className="box-right-listhotels">
                                               
                                                <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${o.customerId}/svspacedet/${o.orderId}`}> Payment Details  </Link></Button>
            
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                                    
                                )
                            })
                        }
                     </article>
                </div>
          

        )
                    }

    }
    


    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title, orders} = this

        return (

            
            <div className="col-md-12">

    
                
                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersTerrain()}></MotelTerrain>
            </div>
        )

    }
}

export default OrderContainer